import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import ContactPage from './components/ContactPage';
import ThankYouPage from './components/ThankYou';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookieSettings from './components/CookieSettings';
import Impressum from './components/Impressum';
import { initializeGA, useAnalytics } from './utils/analytics';

// Analytics wrapper component
const AnalyticsWrapper = ({ children }) => {
  useAnalytics();
  return children;
};

function App() {
  useEffect(() => {
    initializeGA();
  }, []);

  return (
    <BrowserRouter>
      <AnalyticsWrapper>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/cookie-settings" element={<CookieSettings />} />
          <Route path="/impressum" element={<Impressum />} />
        </Routes>
      </AnalyticsWrapper>
    </BrowserRouter>
  );
}

export default App;
